import React from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';

export default ({ categories }) =>(
     <InertiaLink className="w-full flex flex-col mb-3 text-gray-500 hover:text-emerald-500" href={route('site.product.category', {type: categories.type, category:categories.slug})}>
          <div className="flex p-2 bg-gray-100 border border-gray-200 w-full mx-auto rounded overflow-hidden hover:shadow-lg focus:shadow-lg">
               {/*<div className="w-1/3 bg-cover" style={{backgroundImage: `url(${categories.image})`}}></div>*/}

               <div className="w-full p-4 lg:p-4 text-center">
                    <h1 className="text-gray-600 font-semibold text-md hover:text-emerald-700">{categories.name}</h1>
                    {/*<p className="mt-2 text-gray-500 text-sm text-justify">{categories.description}</p>*/}
             </div>
         </div>
     </InertiaLink>
);
